import Button from "./Button.style";
import Heading from "./Heading.style";
import Input from "./Input.style";
import MenuItem from "./Input.style";
import NumberInput from "./NumberInput.style";
import Popover from "./Popover.style";
import Select from "./Select.style";
import Switch from "./Switch.style";

const components = {
  Button,
  Heading,
  Input,
  MenuItem,
  NumberInput,
  Popover,
  Select,
  Switch
};

export default components;
